import { getDroneIntervals } from '../../helpers/getDroneIntervals';
import type { TabKey } from '../../types';

import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslation from 'pages/MaintenancePage/hooks/useTranslation';

import DrawerHead from './components/DrawerHead';
import DrawerTabBody from './components/DrawerTabBody';
import { TABS, TAB_MIN_PHASE, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneDetailDrawer: FunctionComponent<Props> = ({
    activeTab,
    className = '',
    drone,
    droneNames,
    isAdmin,
    isOpen,
    onAdd,
    onClose,
    onEditRecord,
    onOpenLogService,
    onSetAirworthy,
    onSetLifecycle,
    onTabChange,
    onVoidRecord,
    phase,
    records,
    serviceIntervals,
    testId = TEST_ID
}) => {
    const t = useTranslation();
    const openClass = isOpen ? styles.isOpen : '';
    const visibleTabs = TABS.filter(tab => phase >= TAB_MIN_PHASE[tab]);
    const tabLabels: Record<TabKey, string> = {
        components: t.COMPONENTS_TAB,
        health: t.HEALTH_TAB,
        parts: t.PARTS_TAB,
        service: t.SERVICE_TAB,
        warnings: t.WARNINGS_TAB
    };

    return (
        <Wrapper className={className}>
            <Wrapper className={`${styles.scrim} ${openClass}`} onClick={onClose} />

            <VerticalContainer className={`${styles.drawer} ${openClass}`} testId={testId}>
                {drone && (
                    <VerticalContainer className={styles.drawerInner}>
                        <DrawerHead
                            drone={drone}
                            isAdmin={isAdmin}
                            onClose={onClose}
                            onSetAirworthy={onSetAirworthy}
                            onSetLifecycle={onSetLifecycle}
                        />

                        <HorizontalContainer className={styles.drawerTabs}>
                            {visibleTabs.map(tab => {
                                const activeTabClass = activeTab === tab ? styles.isActive : '';

                                return (
                                    <Wrapper
                                        className={`${styles.drawerTab} ${activeTabClass}`}
                                        key={tab}
                                        onClick={() => onTabChange(tab)}>
                                        {tabLabels[tab]}
                                    </Wrapper>
                                );
                            })}
                        </HorizontalContainer>

                        <DrawerTabBody
                            activeTab={activeTab}
                            drone={drone}
                            droneNames={droneNames}
                            isAdmin={isAdmin}
                            onAdd={onAdd}
                            onEditRecord={onEditRecord}
                            onOpenLogService={onOpenLogService}
                            onVoidRecord={onVoidRecord}
                            phase={phase}
                            records={records}
                            serviceIntervals={getDroneIntervals({ drone, serviceIntervals })}
                        />
                    </VerticalContainer>
                )}
            </VerticalContainer>
        </Wrapper>
    );
};

export default DroneDetailDrawer;
